import React from "react";
import {
  Grid,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Typography,
  Checkbox,
} from "@material-ui/core";
import useStyles from "../../styles/companyProfileFormstyle";
import defaultImage from "../../assets/images/default_image.svg";
import AccountEditAndRemoveBtns from "./AccountEditAndRemoveBtns";
import { useTranslation } from "../../langs/useTranslation";

const AccountCardOnlyShow = (props) => {
  const { t } = useTranslation("accountCenter");

  const classes = useStyles();
  const {
    avatarLink,
    name,
    phone,
    email,
    role,
    company_name,
    lastLogin,
    activeStatus,
    otp_required,
    isAdmin,
    handleEditAccount,
    ShowConfirmRemoveAccountButton,
  } = props;

  return (
    <div className={`${classes.mainContent} ${classes.mainContent2}`}>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Typography color="secondary" variant="body1">
            {name}
          </Typography>
        </Grid>
        <Grid item xs={4} className={classes.avatarWrap}>
          <div className="avatar-image">
            <img src={avatarLink || defaultImage} alt="avatar" />
          </div>
        </Grid>
      </Grid>
      <Typography color="secondary" variant="body1">
        {phone || "-"}
      </Typography>
      <Typography color="secondary" variant="body1">
        {email}
      </Typography>
      <Typography color="secondary" variant="body1">
        {role}
      </Typography>
      <Typography color="secondary" variant="body1">
        {company_name}
      </Typography>
      <Typography variant="caption" color="secondary">
        Last Login: {lastLogin}
      </Typography>
      <Grid container alignItems="center" className={classes.buttonGroup}>
        <FormControl
          className={`${classes.activeStatus} ${classes.activeStatusReset}`}
        >
          <FormLabel className={classes.formLabel}>{t("accountProfile.active")}</FormLabel>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  readOnly
                  value={activeStatus}
                  checked={activeStatus === true ? true : false}
                />
              }
              value={props.activeStatus}
            />
          <FormLabel className={classes.formLabel}>{t("accountProfile.2FA")}</FormLabel>
          <FormControlLabel
            control={
              <Checkbox color="primary" readOnly checked={otp_required} />
            }
          />
        </FormControl>
        <AccountEditAndRemoveBtns
          isAdmin={isAdmin}
          ShowConfirmRemoveAccountButton={ShowConfirmRemoveAccountButton}
          handleEditAccount={handleEditAccount}
        />
      </Grid>
    </div>
  );
};

export default AccountCardOnlyShow;
